"use client"

import { ConsentManagerProvider, type ConsentManagerOptions } from "@c15t/nextjs"
import type { ReactNode } from "react"
import { buildConsentManagerOptions } from "./config"

export interface ConsentProviderProps {
  children: ReactNode
  options?: Partial<ConsentManagerOptions>
}

export function ConsentProvider({ children, options }: Readonly<ConsentProviderProps>) {
  return (
    <ConsentManagerProvider options={buildConsentManagerOptions(options)}>
      {children}
    </ConsentManagerProvider>
  )
}
